module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_vm._m(0), _vm._v(" "), _c('pre', {
    attrs: {
      "id": "divClipboard"
    }
  }, [_vm._v(_vm._s(_vm.bidders))])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_vm._m(1), _vm._v(" "), _c('div', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.biddersData),
      expression: "biddersData"
    }],
    staticStyle: {
      "border": "1px solid black",
      "padding": "10px"
    },
    attrs: {
      "placeholder": "Enter data",
      "rows": "4",
      "cols": "150"
    },
    domProps: {
      "value": (_vm.biddersData)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.biddersData = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addData
    }
  }, [_vm._v("Submit")])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("ads.txt")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Please add domain specific ads.txt entries here")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2381a805!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/admin/AdsText.vue
// module id = 664
// module chunks = 2